module.exports = __webpack_public_path__ + "img/hubspot_property.a1c4708e.png";